import React from "react";
import { Stack } from "@mantine/core";
import {
  AboutYourselfData,
  ABOUT_YOURSELF_QUESTIONS,
  QUESTION_KEYS,
} from "../types/onboarding";
import ChipGroupSingle from "../components/ChipGroupSingle";
import styles from "./AboutYourselfStepContent.module.css";

interface AboutYourselfStepContentProps {
  data: AboutYourselfData;
  onChange: (
    data: Partial<AboutYourselfData>,
    questionKey?: string,
    questionValue?: string,
    answerValue?: string,
  ) => void;
}

export default function AboutYourselfStepContent({
  data,
  onChange,
}: AboutYourselfStepContentProps) {
  const titleQuestion = ABOUT_YOURSELF_QUESTIONS.find(
    (q) => q.questionKey === QUESTION_KEYS.WHATS_YOUR_TITLE,
  );
  const referralQuestion = ABOUT_YOURSELF_QUESTIONS.find(
    (q) => q.questionKey === QUESTION_KEYS.HOW_DID_YOU_HEAR_ABOUT_US,
  );

  const handleTitleChange = (value: string | null) => {
    onChange(
      { title: value },
      QUESTION_KEYS.WHATS_YOUR_TITLE,
      titleQuestion?.questionText || "What's your title?",
      value || "",
    );
  };

  const handleReferralChange = (value: string | null) => {
    onChange(
      { referralSources: value ? [value] : [] },
      QUESTION_KEYS.HOW_DID_YOU_HEAR_ABOUT_US,
      referralQuestion?.questionText || "How did you hear about us?",
      value || "",
    );
  };

  return (
    <Stack className={styles.container}>
      <Stack gap="xl" className={styles.scrollableContent}>
        {titleQuestion && (
          <ChipGroupSingle
            label={titleQuestion.questionText}
            options={
              titleQuestion.options?.map((opt) => ({
                value: opt,
                label: opt,
              })) || []
            }
            value={data.title}
            onChange={handleTitleChange}
          />
        )}

        {referralQuestion && (
          <ChipGroupSingle
            label={referralQuestion.questionText}
            options={
              referralQuestion.options?.map((opt) => ({
                value: opt,
                label: opt,
              })) || []
            }
            value={data.referralSources[0] || null}
            onChange={handleReferralChange}
          />
        )}
      </Stack>
    </Stack>
  );
}
